export const handleMouseMove =
    (containerRef: React.RefObject<HTMLDivElement>, maxTilt: number, scale: number) => (e: React.MouseEvent) => {
        const el = containerRef.current
        if (!el) return

        const { left, top, width, height } = el.getBoundingClientRect()
        const x = e.clientX - left
        const y = e.clientY - top

        const rotateX = ((y / height - 0.5) * -2 * maxTilt).toFixed(2)
        const rotateY = ((x / width - 0.5) * 2 * maxTilt).toFixed(2)

        el.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`
    }

export const handleMouseLeave = (containerRef: React.RefObject<HTMLDivElement>) => () => {
    const el = containerRef.current
    if (el) {
        el.style.transform = 'perspective(1000px) rotateX(0deg) rotateY(0deg) scale(1)'
    }
}
